<template>
    <div class="d-inline-block">
        <fullscreen-loading v-if="loading"/>

        <button
            v-if="withtext"
            type="button"
            class="btn btn-company btn-sm rounded-pill float-right mr-2"
            @click="downloadFile('zip')"
            v-tooltip="$t('download.zip_file')"
        >
            <span class="btn-inner--icon">
                <icon name="download"></icon>
            </span>
            <span class="btn-inner--text">{{ $t('download.button_text') }}</span>
        </button>

        <button
            v-else
            type="button"
            class="btn btn-xs rounded-pill btn-company-orange mr-2"
            @click="downloadFile('zip')"
            v-tooltip="$t('download.zip_file')"
        >
            <icon name="download" scale="0.8"></icon>
        </button>
    </div>
</template>

<script>
import FullscreenLoading from "../../components/FullscreenLoading.vue";

export default {
    components: {FullscreenLoading},
    props: {
        filename: {
            type: String,
            required: true,
        },
        href: {
            type: String,
            required: true,
        },
        withtext: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            loading: false,
        };
    },
    methods: {
        async downloadFile(type = 'zip') {
            this.loading = true;

            try {
                // Append type to the URL so the server knows which format to return.
                const fetchUrl = `${this.href}?type=${type}`;

                const response = await this.$http.get(fetchUrl, { responseType: 'blob' });

                // Attempt to extract filename from Content-Disposition header
                let filenameFromServer = this.filename;
                const contentDisposition = response.headers['content-disposition'];
                if (contentDisposition && contentDisposition.indexOf('filename=') !== -1) {
                    const match = contentDisposition.match(/filename="?([^"]+)"?/);
                    if (match && match[1]) {
                        filenameFromServer = match[1];
                    }
                }

                const url = URL.createObjectURL(new Blob([response.data]));
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;

                // Use the filename from the server if found, else fall back to the local filename prop.
                a.download = filenameFromServer;

                document.body.appendChild(a);
                a.click();
                URL.revokeObjectURL(url);
            } catch (exception) {
                if (exception.response && exception.response.status !== 200) {
                    alert('Failed to download file');
                }
            }

            this.loading = false;
        }
    },
};
</script>
